import React from 'react';
import { Formik } from 'formik';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const CreateUser = () => {
    const navigate = useNavigate();

    return (
        <React.Fragment>
            <main>
                <h1>Create New User</h1>
                <section>
                    <article>
                        <Formik 
                            initialValues={{ firstName: '', lastName: '', email: '', patientNumber: '', phoneNumber: '', username: '', password: ''}}
                            onSubmit={(values, { setSubmitting }) => { 
                                setTimeout(() => { 
                                    let result = JSON.stringify(values, null, 2);
                                    axios.post('http://localhost:5000/CreateUser', { firstName: values.firstName, lastName: values.lastName, email: values.email, patientNumber: values.patientNumber, phoneNumber: values.phoneNumber, username: values.username, password: values.password })
                                        .then((response) => { 
                                            if (response.status === 200) {
                                                navigate('/Admin/Users');
                                            }
                                        })
                                        .catch((error) => { 
                                            console.log(error);
                                        });
                                    setSubmitting(false);
                                }, 400);
                            }}
                            >
                                {({
                                    values, 
                                    errors, 
                                    touched, 
                                    handleChange, 
                                    handleBlur ,
                                    handleSubmit,
                                    isSubmitting,
                                }) => (
                                    <form onSubmit={handleSubmit}>
                                        <div className="formContainer">
                                            <label htmlFor="firstName">First Name:</label>
                                            <input type="text" id="firstName" name="firstName" onChange={handleChange} onBlur={handleBlur} values={values.firstName} placeholder="First Name" />
                                        </div>
                                        <div className="formContainer">
                                            <label htmlFor="lastName">Last Name:</label>
                                            <input type="text" id="lastName" name="lastName" onChange={handleChange} onBlur={handleBlur} values={values.lastName} placeholder="Last Name" />
                                        </div>
                                        <div className="formContainer">
                                            <label htmlFor="email">Email:</label>
                                            <input type="email" id="email" name="email" onChange={handleChange} onBlur={handleBlur} values={values.email} placeholder="Email" />
                                        </div>
                                        <div className="formContainer">
                                            <label htmlFor="patientNumber">Patient Number:</label>
                                            <input type="text" id="patientNumber" name="patientNumber" onChange={handleChange} onBlur={handleBlur} values={values.patientNumber} placeholder="Patient Number" />
                                        </div>
                                        <div className="formContainer">
                                            <label htmlFor="phoneNumber">Phone Number:</label>
                                            <input type="text" id="phoneNumber" name="phoneNumber" onChange={handleChange} onBlur={handleBlur} values={values.phoneNumber} placeholder="Phone Number" />
                                            
                                        </div>
                                        <div className="formContainer">
                                            <label htmlFor="username">Username:</label>
                                            <input type="text" id="username" name="username" onChange={handleChange} onBlur={handleBlur} values={values.username} placeholder="Username" />
                                        </div>
                                        <div className="formContainer">
                                            <label htmlFor="password">Password:</label>
                                            <input type="password" id="password" name="password" onChange={handleChange} onBlur={handleBlur} values={values.password} placeholder="Password" />
                                        </div>
                                            <button type="Submit">Submit</button>
                                    </form>
                                )}
                        </Formik>
                    </article>
                    <article>
                        <img src={require('../../../assets/images/ipad.png')} />
                    </article>
                </section>
            </main>
        </React.Fragment>
    )
}

export default CreateUser;